export default __webpack_public_path__ + "images/6d83e8caa9b1e1a574069dac9798f0a0.png";